import React from 'react';
import ReactDOM from 'react-dom';
import Restore from 'react-restore';
import App from '../App';
import store from '../store';
import '../js';
const SendApp = Restore.connect(App, store);
ReactDOM.render(React.createElement(SendApp, null), document.getElementById('root'));
